import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

export const FEELINGS = ["Grounded", "Confident", "Open", "Magnetic", "Calm"];
export const NOW_FEELINGS = ["Tense", "Overthinking"];

const Chip = ({ f, value, onPick }) => (
  <button onClick={() => onPick(f)} data-testid={`routine-feeling-${f.toLowerCase()}`}
    className={`px-4 py-2 rounded-full text-sm border transition-colors duration-300 ${value === f ? "bg-primary text-primary-foreground border-primary" : "border-border text-foreground/80 hover:border-primary/50"}`}>{f}</button>
);

export function FeelingChips({ value, onPick, nowOnly = false }) {
  return (
    <div className="mb-10" data-testid="routine-feeling">
      {!nowOnly && (
        <>
          <p className="text-sm text-muted-foreground mb-3">How do you want to feel today?</p>
          <div className="flex flex-wrap gap-2 mb-5">{FEELINGS.map((f) => <Chip key={f} f={f} value={value} onPick={onPick} />)}</div>
        </>
      )}
      <p className="text-sm text-muted-foreground mb-3">{nowOnly ? "Feeling any of these tonight?" : "Or right now, are you feeling…"}</p>
      <div className="flex flex-wrap gap-2">{NOW_FEELINGS.map((f) => <Chip key={f} f={f} value={value} onPick={onPick} />)}</div>
    </div>
  );
}

export function PickCard({ p, onOpen, i = 0, testId }) {
  return (
    <motion.button initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.15 + i * 0.08 }}
      onClick={() => onOpen(p)} data-testid={testId}
      className="group w-full text-left rounded-3xl border border-border bg-card/40 hover:bg-card/70 p-5 transition-colors duration-300">
      {p.eyebrow && <p className="text-[10px] uppercase tracking-[0.22em] text-primary mb-1.5">{p.eyebrow}</p>}
      {p.why && <p className="text-sm text-muted-foreground mb-2">{p.why}</p>}
      <div className="flex items-center justify-between gap-3">
        <span className="font-serif text-xl">{p.label} <span className="text-sm text-muted-foreground font-sans">· {p.duration}</span></span>
        <span className="text-sm text-primary flex items-center gap-1 shrink-0">Start <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" /></span>
      </div>
    </motion.button>
  );
}

export function TodayForYou({ picks, onOpen }) {
  if (!picks?.length) return null;
  return (
    <section className="mb-12" data-testid="routine-today-for-you">
      <h2 className="text-xs uppercase tracking-[0.22em] text-foreground/90">Today for you</h2>
      <p className="text-xs text-muted-foreground mb-4">Chosen by your Coach</p>
      <div className="space-y-3">{picks.map((p, i) => <PickCard key={p.key} p={p} i={i} onOpen={onOpen} testId={`routine-pick-${p.key}`} />)}</div>
    </section>
  );
}
